import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@app/core';
import classnames from 'classnames';
import classNames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  banner: {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,

    backgroundColor: theme.colors.purpleAccessible,
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.marginBase,
  },
  text: {
    ...theme.fonts.label,
    color: theme.colors.white,
  },
  icon: {
    fontSize: theme.iconSize.small,
    marginLeft: theme.marginBase,
    color: theme.colors.white,
  },
}));

interface Props {
  className?: string;
}

const BANNER_ACTIVE = window.location.hostname.endsWith('tandemz.io');

export const NewFeatureBanner = ({ className }: Props) => {
  if (!BANNER_ACTIVE) {
    return null;
  }
  const classes = useStyles();
  const link = 'https://app.bilendi-ux.com';
  return (
    <Link
      className={classnames(classes.banner, className)}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className={classes.text}>
        <Trans i18nKey="newFeatureBanner" />
      </div>
      <i className={classNames('ri-share-box-line', classes.icon)} />
    </Link>
  );
};
